export default __webpack_public_path__ + "static/media/two.5114a2d4.svg";